var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9738 16.2296C17.6155 16.5741 17.0458 16.5629 16.7012 16.2046L12.25 11.4793L7.79875 16.2046C7.45424 16.5629 6.8845 16.5741 6.5262 16.2296C6.16791 15.8851 6.15674 15.3153 6.50125 14.957L11.6013 9.55704C11.7709 9.38057 12.0052 9.28083 12.25 9.28083C12.4948 9.28083 12.7291 9.38057 12.8987 9.55704L17.9987 14.957C18.3433 15.3153 18.3321 15.8851 17.9738 16.2296Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.daf049a59db2ba34be5db4803d92e7ec.svg";
export { ForwardRef as ReactComponent };